import React from 'react';
import PropTypes from 'prop-types';
import ProsConsCard, {
  PROS,
  CONS,
  PROSCACHE,
  CONSCACHE
} from '../../../shared/library/cards/pros-cons';
import NavAnchor from '../components/shared/nav-anchor';
import {RenderItems, GridItem} from '../components/shared/render';
import Title from '../components/shared/title';
import SignUpPanel from '../../../shared/library/panels/sign-up';
import {NAVBAR_HEIGHT} from '../../../shared/style/dimensions';

const NAV_BAR_HEIGHT = 90;
const TOOL_CARD_STICKY_HEIGHT = 72;
const NAV_ANCHOR_OFFSET = NAV_BAR_HEIGHT + TOOL_CARD_STICKY_HEIGHT + NAVBAR_HEIGHT + 20;

const ProsCons = ({
  showPros,
  showCons,
  num,
  tools,
  privateMode,
  analyticsData,
  showLoggedOutCta
}) => {
  return (
    <>
      {(showPros || showCons) && <NavAnchor id="pros" offset={NAV_ANCHOR_OFFSET} span={num} />}

      {showPros && (
        <>
          <RenderItems tools={tools} num={num} titleRow={true}>
            {tool => <Title copy={`Pros of ${tool.name}`} />}
          </RenderItems>

          <RenderItems tools={tools} num={num} titleRow={showLoggedOutCta}>
            {tool => (
              <ProsConsCard
                limitItems={tool[PROSCACHE].count}
                type={PROS}
                privateMode={privateMode}
                slug={tool.slug}
                name={tool.name}
                items={tool[PROSCACHE]}
                title={`Pros of ${tool.name}`}
              />
            )}
          </RenderItems>
        </>
      )}

      {showLoggedOutCta && showPros && (
        <GridItem span={num}>
          <SignUpPanel
            heading="Sign up to add or upvote pros"
            callout="Make informed product decisions"
            cta="Sign up now"
            section="Stackups"
            analyticsPayload={analyticsData}
          />
        </GridItem>
      )}

      {showCons && (
        <>
          <RenderItems tools={tools} num={num} titleRow={true}>
            {tool => <Title copy={`Cons of ${tool.name}`} />}
          </RenderItems>
          <RenderItems tools={tools} num={num} titleRow={showLoggedOutCta}>
            {tool => (
              <ProsConsCard
                limitItems={tool[CONSCACHE].count}
                type={CONS}
                privateMode={privateMode}
                slug={tool.slug}
                name={tool.name}
                items={tool[CONSCACHE]}
                title={`Cons of ${tool.name}`}
              />
            )}
          </RenderItems>
        </>
      )}

      {showLoggedOutCta && showCons && (
        <GridItem span={num}>
          <SignUpPanel
            heading="Sign up to add or upvote cons"
            callout="Make informed product decisions"
            cta="Sign up now"
            section="Stackups"
            analyticsPayload={analyticsData}
          />
        </GridItem>
      )}
    </>
  );
};

ProsCons.propTypes = {
  num: PropTypes.number,
  tools: PropTypes.array,
  privateMode: PropTypes.any,
  showPros: PropTypes.bool,
  showCons: PropTypes.bool,
  analyticsData: PropTypes.any,
  showLoggedOutCta: PropTypes.any
};

export default ProsCons;
